import { useEffect } from "react";
import { Outlet } from "react-router-dom";

import useMediaQuery from "@mui/material/useMediaQuery";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";

// project imports
import Drawer from "./Drawer";
import Header from "./Header";
import Footer from "./Footer";
import Loader from "components/Loader";
import useConfig from "hooks/useConfig";
import { DRAWER_WIDTH, MINI_DRAWER_WIDTH } from "config";

import { handlerMobileDrawerOpen, useGetMenuMaster } from "api/menu";

// ==============================|| MAIN LAYOUT ||============================== //

export default function DashboardLayout() {
  const { menuMasterLoading, menuMaster } = useGetMenuMaster();
  const { state } = useConfig();
  const downLG = useMediaQuery((theme) => theme.breakpoints.down("lg"));
  const downMD = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const drawerOpen = menuMaster?.isDesktopDrawerExpanded ?? true;

  useEffect(() => {
    if (downLG) {
      handlerMobileDrawerOpen(false);
    }
  }, [downLG]);

  if (menuMasterLoading) return <Loader />;

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        minHeight: "100dvh",
        overflow: "hidden",
      }}
    >
      <Header />
      <Drawer />

      <Box
        component="main"
        sx={{
          width: {
            xs: "100%",
            lg: drawerOpen
              ? `calc(100% - ${DRAWER_WIDTH}px)`
              : `calc(100% - ${MINI_DRAWER_WIDTH}px)`,
          },
          flexGrow: 1,
          px: 0,
          pt: 0,
          pb: 0,
          height: "100dvh",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Toolbar sx={{ mt: "inherit" }} />
        <Box
          sx={{
            position: "relative",
            flex: 1,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            px: { xs: 0, sm: 1.5, lg: 2 },
            pb: { xs: 0, sm: 1.5, lg: 0 },
          }}
        >
          {state.layout === "container" ? (
            <Container
              maxWidth="xl"
              disableGutters={downMD}
              sx={{
                flex: 1,
                minHeight: 0,
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                px: { xs: 0, sm: 0, md: 0 },
              }}
            >
              <Box
                sx={{
                  flex: 1,
                  minHeight: 0,
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                  overscrollBehaviorY: "none",
                  px: { xs: 0, sm: 0.5, md: 0 },
                  pb: { xs: 0, sm: 1 },
                }}
              >
                <Outlet />
              </Box>
              <Footer />
            </Container>
          ) : (
            <Box
              sx={{
                flex: 1,
                minHeight: 0,
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  flex: 1,
                  minHeight: 0,
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                  overscrollBehaviorY: "none",
                  px: { xs: 0, sm: 0.5, md: 0 },
                  pb: { xs: 0, sm: 1 },
                }}
              >
                <Outlet />
              </Box>
              <Footer />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
}
